module.exports = __webpack_public_path__ + "img/28.d7b36d84.jpeg";